<template>
  <gj-table
      ref="gjTable"
      adapt-parent
      :index="false"
      :loading="loading"
      :data="tableData"
      :columns="columns"
      :show-overflow="false"
      :offset-height="55"
      @page-change="$gjNoticeQuery">
    <template v-slot:sku="{row}">
      <div>
        <gj-text>{{row.productName | defaultShow}}</gj-text>
      </div>
      <div>{{row.sku | defaultShow}}</div>
      <div>{{row.productType | optionText(productTypeOption)}} - {{row.categoryName | defaultShow}}</div>
    </template>
  </gj-table>
</template>

<script>
  import {queryMixin} from "../../../../../../minxins";
  import {getDeliveryOrderList} from "../../../../../../api/purchase";

  export default {
    name: "app-delivery-order-inbound",
    mixins: [queryMixin],
    props: {
      deliveryOrder: {
        required: true
      }
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'inboundCode', header: '入库单号', field: 'inboundCode', width: '135px', fixed: 'left'},
          // {id: 'purchaseOrder', header: '采购单号', field: 'purchaseOrder', width: '120px'},
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '60px', fixed: 'left'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '200px', fixed: 'left'},
          {id: 'deliveryQuantity', header: '交货量', field: 'deliveryQuantity', width: '80px', align: 'right'},
          {id: 'includeTaxPrice', header: '含税单价', field: 'includeTaxPrice', prefix: 'priceCurrencySymbol', width: '100px', align: 'right'},
          {id: 'amount', header: '入库金额', field: 'amount', prefix: 'priceCurrencySymbol', width: '100px', align: 'right'},
          {id: 'unitFee', header: '单位费用', field: 'unitFee', prefix: 'feeCurrencySymbol', width: '100px', align: 'right'},
          {id: 'inboundFee', header: '入库费用', field: 'inboundFee', prefix: 'feeCurrencySymbol', width: '100px', align: 'right'},
          {id: 'changeQuantity', header: '入库良品量', field: 'changeQuantity', width: '100px', align: 'right'},
          {id: 'changeBadQuantity', header: '入库次品量', field: 'changeBadQuantity', width: '100px', align: 'right'},
          {id: 'expectDeliveryDate', header: '预计交货日期', field: 'expectDeliveryDate', width: '120px'},
          {id: 'actualDeliveryDate', header: '实际交货日期', field: 'actualDeliveryDate', width: '120px'},
          {id: 'memo', header: '备注', field: 'memo', minWidth: '250px'},
        ]
      }
    },
    methods: {
      $gjQuery() {
        this.loading = true;
        getDeliveryOrderList(this.deliveryOrder.id)
          .then(data => {
            this.tableData = data;
          })
          .complete(() => this.loading = false);
      }
    }
  }
</script>

<style scoped>

</style>
